import { render, staticRenderFns } from "./AssignedToAppointmentNotification.vue?vue&type=template&id=70c11514&scoped=true&"
import script from "./AssignedToAppointmentNotification.vue?vue&type=script&lang=js&"
export * from "./AssignedToAppointmentNotification.vue?vue&type=script&lang=js&"
import style0 from "./AssignedToAppointmentNotification.vue?vue&type=style&index=0&id=70c11514&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c11514",
  null
  
)

export default component.exports